import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import moment from "moment";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  month: number;
  year: number;
  data: { label: string; value: string }[];
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  month: moment().month() + 1,
  year: moment().year(),
  data: [],
};

const getListFeedbackSlice = createSlice({
  name: "getListFeedback",
  initialState,
  reducers: {
    setMonthYearListFeedback: (
      state,
      action: PayloadAction<{ month: number; year: number }>
    ) => {
      state.month = action.payload.month;
      state.year = action.payload.year;
    },
    getListFeedbackStart: (state, action: PayloadAction<object>) => {
      state.status = ReduxStateType.LOADING;
    },
    getListFeedbackSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getListFeedbackFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    updateListFeedback: (state, action) => {
      state.data = action.payload;
    },
    resetListFeedback: () => {
      return { ...initialState };
    },
  },
});

export const {
  setMonthYearListFeedback,
  getListFeedbackStart,
  getListFeedbackSuccess,
  getListFeedbackFailed,
  updateListFeedback,
  resetListFeedback,
} = getListFeedbackSlice.actions;

export default getListFeedbackSlice.reducer;
